import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions/index';
import * as $ from "jquery";
import ScanSearchResult from "../../component/History/ScanSearchResult";
class SearchHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      result: 'No result',
      loading: false,
      search: {
        area_type_id: null,
        floor_id: null,
        area_name: null,
        page: 1,
        size: 15,
        totalCount: 0
      },
      showCommentModal: false,
      frontlineTaskId: null,
      commentAreaId: null,
    };
    this.handlePageChange = this.handlePageChange.bind(this)

  }

  getHistory(params, id) {
    return  this.props.getSearchHistory(params, id)
  }
  componentDidMount() {
    $('.login100-more').addClass("d-none");
    if (this.props.areaSearchResult ) {
      if (this.props.user && this.props.user.role === "frontline") {
        this.props.createAreaTask(this.props.areaSearchResult.id).then(res => {
          if (res.value){
            const frontlineTaskId = res.value.data && res.value.data.frontline_task && res.value.data.frontline_task.id;
            const checkCommentEnabled = (val) => val === true || val === "true" || val === 1 || val === "1";
            const isCommentEnabled =
              checkCommentEnabled(this.props.areaSearchResult && this.props.areaSearchResult.enable_frontline_comment) ||
              checkCommentEnabled(res.value && res.value.data && res.value.data.area && res.value.data.area.enable_frontline_comment) ||
              checkCommentEnabled(res.value && res.value.data && res.value.data.frontline_task && res.value.data.frontline_task.area && res.value.data.frontline_task.area.enable_frontline_comment);

            this.setState({
              showCommentModal: isCommentEnabled,
              frontlineTaskId,
              commentAreaId: this.props.areaSearchResult.id
            });
            this.getHistory({
              page: this.state.search.page,
              size: this.state.search.size,
              "area_id": this.props.areaSearchResult.id,
              "area_type_id": this.props.areaSearchResult.area_type.id,
              "floor_no": this.props.areaSearchResult.floor_no,
              "area_name": this.props.areaSearchResult.name
            }, this.props.areaSearchResult.account.token).then(() => {
              // if (this.props.user && this.props.user.role === "frontline") setTimeout(() => this.props.history.push("/scan_qr"), 15000);
            })
          }
        })
      } else {
        this.getHistory({
          page: this.state.search.page,
          size: this.state.search.size,
          "area_id": this.props.areaSearchResult.id,
          "area_type_id": this.props.areaSearchResult.area_type.id,
          "floor_no": this.props.areaSearchResult.floor_no,
          "area_name": this.props.areaSearchResult.name
        }, this.props.areaSearchResult.account.token);
      }
    }
    else if (this.props.user && this.props.user.role === "frontline") {
      this.props.history.push("/scan_qr")
    } else if (!this.props.searchHistory) {
      this.props.history.push(`/account/${this.props.match.params.accountId}`);
    }
    //if (isEmpty(this.props.areaTypes)) {
    //  this.props.getAreaTypes();
    //}
  }
  scheduleTask= (id) => {
    this.props.createAreaTask(id)
  };
  componentWillUnmount() {
    $('.login100-more').removeClass("d-none");
  }
  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    let search = {...this.state.search};
  search.page = pageNumber;
    this.setState({search});
    this.getHistory({...search,
    "area_id": this.props.searchHistory.last_sync.area.id,
    "area_type_id": this.props.searchHistory.last_sync.area.area_type.id,
    "floor_no": this.props.searchHistory.last_sync.area.floor.id,
    "area_name": this.props.searchHistory.last_sync.area.name
    }, this.props.searchHistory.last_sync.area.account.token)
  }
  render() {
    return (
        <>
        <ScanSearchResult
            {...this.props}
            search = {this.state.search}
            total_no_of_pages={this.props.total_no_of_pages}
            token={this.props.match.params.accountId}
            handlePageChange={this.handlePageChange}
            scheduleTask={this.scheduleTask}
            showCommentModal={this.state.showCommentModal}
            frontlineTaskId={this.state.frontlineTaskId}
            commentAreaId={this.state.commentAreaId}
            onCloseCommentModal={() => this.setState({ showCommentModal: false })}
            getFrontlineCommentPresignUrl={this.props.getFrontlineCommentPresignUrl}
            submitFrontlineComment={this.props.submitFrontlineComment}
            />
        </>

    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    isLoading: state.adminOrSuperAdminReducer.isLoading,
    total_no_of_pages: state.adminOrSuperAdminReducer.total_no_of_pages,
    areaSearchResult: state.adminOrSuperAdminReducer.areaSearchResult,
    searchHistory: state.adminOrSuperAdminReducer.searchHistory,
    searchHistoryFilter: state.adminOrSuperAdminReducer.searchHistoryFilter
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSearchHistory: (params,id) => dispatch(actions.searchHistory(params,id)),
    createAreaTask: (id) => dispatch(actions.createAreaTask(id)),
    exportCleaningHistory:(body,accountId)=>dispatch(actions.exportCleaningHistory(body,accountId)),
    getFrontlineCommentPresignUrl:(area_id, extentions)=>dispatch(actions.getFrontlineCommentPresignUrl(area_id, extentions)),
    submitFrontlineComment:(body, area_id)=>dispatch(actions.submitFrontlineComment(body, area_id)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(SearchHistory);
//export default SearchHistory;